// The CPD Certification Service's "E-learning Delegate Feedback Form".
// The wording is CPD UK's and must not be edited. Bands and statement keys
// mirror server/src/models/training/feedbackFields.js, which validates the
// submission - keep the two in step.

export const COMPLETION_TIME_BANDS = [
  'Less than 10 minutes',
  '10–30 minutes',
  '30–60 minutes',
  '1–2 hours',
  'More than 2 hours',
]

export const USABILITY_STATEMENTS = [
  { key: 'easyToNavigate', text: 'The website was easy to navigate' },
  { key: 'linksWorked', text: 'All links worked correctly' },
  { key: 'structureClear', text: 'The course structure and progression were clear' },
  { key: 'textReadable', text: 'The fonts and text were easy to read' },
  { key: 'enoughInteractivity', text: 'There was enough interactivity' },
  { key: 'assessmentsRelevant', text: 'The assessments asked relevant questions' },
  { key: 'easyToContactSupport', text: 'It was easy to contact support or administrators' },
  { key: 'fitSchedule', text: 'The course fit well with my schedule' },
  { key: 'feltRushed', text: 'I felt rushed while completing the course' },
  { key: 'feedbackHighlightedImprovement', text: 'The feedback highlighted areas for improvement' },
  { key: 'videoFatigue', text: 'I felt fatigued by the amount of video content' },
  { key: 'preparedToApply', text: 'I feel prepared to apply what I learned in a real-world setting' },
]

export const MAX_FREE_TEXT = 2000

export const FORM_TEXT = {
  title: 'E-learning Delegate Feedback Form',
  intro: 'Delegates are kindly asked to complete the feedback form in order to receive their certificate.',
  // Shown only for a course version that CPD UK has certified.
  accredited:
    'This e-learning course has been independently reviewed and certified as meeting internationally recognised Continuing Professional Development (CPD) guidelines.',
  thanks:
    'Thank you for completing this E-learning course. Your feedback helps us ensure our CPD activities remain high-quality, relevant, and engaging. We would appreciate your feedback by answering the questions below.',
  closing:
    'Thank you for completing this delegate evaluation and feedback form. We appreciate your time and insights and look forward to supporting your continued professional development.',
}

export const SECTIONS = {
  completionTime: {
    heading: '1. Course Completion Time',
    question: 'Approximately how long did it take you to complete the course?',
  },
  overallExperience: {
    heading: '2. Overall Learning Experience',
    question: 'How would you rate your overall online learning experience?',
    high: 'Positive',
    low: 'Negative',
  },
  multimediaQuality: {
    heading: '3. Multimedia Quality',
    question: 'How would you rate the quality of the multimedia content (e.g. videos, visuals, audio)?',
    high: 'High Quality',
    low: 'Low Quality',
  },
  usability: {
    heading: '4. Course Design and Usability',
    question: 'Please indicate Yes or No for each statement:',
  },
  additionalResources: {
    heading: '5. Additional Resources',
    question: 'Did you access any additional or external resources? If so, were they helpful?',
  },
  topicsForMoreDepth: {
    heading: '6. Course Content',
    question: 'Which topics would you like to see covered in more depth or with further follow-up?',
  },
  improvements: {
    heading: '7. Suggestions for Improvement',
    question: 'Please share up to three ways this course could be improved:',
  },
  postCompletionEngagement: {
    heading: '8. Post-Completion Engagement',
    question: 'Did you return to any of the material after completing the course? If so, why?',
  },
  mostFrustrating: {
    heading: '9. Challenges',
    question: 'What was the most frustrating part of the course for you?',
  },
}
